/**
 * Copyright © 2026 Adnuntius AS.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {TabsModule} from 'ngx-bootstrap/tabs';

import {CountrySelectComponent} from '../../common/directives/country-select/country-select';
import {FormControlsModule} from '../../common/directives/form-controls/form-controls.module';
import {AppSharedModule} from '../../common/app-shared.module';
import {SimplePagesModule} from '../simple/simple-pages.module';
import {AdnDocsPageComponent} from './adn-docs-page.component';
import {AiHowConnectPageComponent} from './ai-how-connect-page.component';
import {DummyPageComponent} from './dummy-page.component';
import {NudePreviewPageComponent} from './nude-preview-page.component';
import {ReleaseNotesPageComponent} from './release-notes-page.component';
import {UpdateAdvertiserPageComponent} from './update-advertiser-page.component';

const NUDE_PAGES = [
  AdnDocsPageComponent,
  AiHowConnectPageComponent,
  DummyPageComponent,
  NudePreviewPageComponent,
  ReleaseNotesPageComponent,
  UpdateAdvertiserPageComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    FormsModule,
    TranslateModule,
    UIRouterModule,
    TabsModule,
    CountrySelectComponent,
    FormControlsModule,
    SimplePagesModule
  ],
  declarations: NUDE_PAGES,
  exports: NUDE_PAGES
})
export class NudePagesModule {
}
